<template>
    <div>
      <div class="title whiteBox">{{ $t('view.企业认证') }}</div>
      <div class="whiteBox">
        <div class="annexList" v-if="details.businessLicenseFileList">
            <div style="width: 100px;">{{$t('view.营业执照')}}：</div>
            <div style="flex: 1" v-if="!details.businessLicenseFileList.length">
                <el-upload 
                    :action="uploadFile" 
                    :limit="1"
                    :before-upload="beforeAvatarUpload"
                    :class="{'hide': details.businessLicenseFileList.length==1}"
                    :headers="headers" :on-success="(res,file)=>{successList(details.businessLicenseFileList,res,file)}"
                      :on-remove="(res,file)=>{handleRemove('businessLicenseFileList',res,file)}">
                    <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    <span slot="tip" style="margin-left: 10px;" class="el-upload__tip">{{ $t('view.上传营业执照副本，仅用于资质审核') }}</span>
                </el-upload>
            </div>
            <div v-else style="display: flex;">
              <File :clsoe="true" :listName="'businessLicenseFileList'" :file="details.businessLicenseFileList[0]"></File>
            </div>
        </div>
        <div class="annexList" v-if="details.achievementFileList">
            <div style="width: 100px;">{{$t('view.业绩')}}：</div>
            <div style="flex: 1" v-if="!details.achievementFileList.length">
                <el-upload 
                    :action="uploadFile" 
                    :limit="1"
                    :before-upload="beforeAvatarUpload"
                    :class="{'hide': details.achievementFileList.length==1}"
                    :headers="headers" :on-success="(res,file)=>{successList(details.achievementFileList,res,file)}" 
                    :on-remove="(res,file)=>{handleRemove('achievementFileList',res,file)}">
                    <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    <span slot="tip" style="margin-left: 10px;" class="el-upload__tip">{{ $t('view.上传以往业绩合同附件，仅用于资质审核') }}</span>
                </el-upload>
            </div>
            <div v-else style="display: flex;">
              <File :clsoe="true" :listName="'achievementFileList'" :file="details.achievementFileList[0]"></File>
            </div>
        </div>
        <div class="annexList" v-if="details.agencyLicenseFileList">
            <div style="width: 100px;">{{ $t('view.代理许可证') }}：</div>
            <div style="flex: 1" v-if="!details.agencyLicenseFileList.length">
                <el-upload 
                    :limit="1"
                    :action="uploadFile" 
                    :class="{'hide': details.agencyLicenseFileList.length==1}"
                    :before-upload="beforeAvatarUpload"
                    :headers="headers" :on-success="(res,file)=>{successList(details.agencyLicenseFileList,res,file)}"
                    :on-remove="(res,file)=>{handleRemove('agencyLicenseFileList',res,file)}">
                    <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                </el-upload>
            </div>
            <div v-else style="display: flex;">
              <File :clsoe="true" :listName="'agencyLicenseFileList'" :file="details.agencyLicenseFileList[0]"></File>
            </div>
        </div>
        <el-button type="primary" style="margin: 10px 0;" size="mini" @click="bidCompanyPut">{{ $t('view.提交') }}</el-button>
      </div>
      <el-image ref="preview" v-show='false' class="hideImgDiv" :src="url" :preview-src-list="[url]" ></el-image>
    </div>
  </template>
    
<script>
import {bidCompany,bidCompanyPut} from '@/api/PersonalCenter'
import { uploadFile } from '@/utils/request'
import { getToken } from "@/utils/auth";
import File from '@/components/file.vue'
  export default {
    components:{File},
    data(){
      return{
        uploadFile,
        url:'',
        locale: localStorage.getItem('locale')||'zh',
        headers: {
            Authorization:getToken(),
        },
        reupload:false,//资质上传 重新上传的判断
        details:{}
      }
    },
    created(){
      this.bidCompany()
    },
    methods:{
      // 查看图片
      viewPicture(img){
        this.url=img
        this.$refs.preview.clickHandler();
      },
      // 附件查看与下载
      handleViewFile(filePath, fileName) {
        const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
        if (ext == 'pdf' || 'PDF') {
            window.open(filePath, "_blank");
        } else {
            const eLink = document.createElement("a");
            eLink.download = fileName;
            eLink.style.display = "none";
            eLink.href = filePath;
            document.body.appendChild(eLink);
            eLink.click();
            eLink.remove()
        }
      },
      // 重新上传
      reuploadClick(list){
        this.$set(this.details,list,[])
      },
      // 提交资质
      bidCompanyPut(){
          bidCompanyPut({
              id:this.$store.getters.companyId,
              businessLicenseFileList:this.details.businessLicenseFileList,
              achievementFileList:this.details.achievementFileList,
              agencyLicenseFileList:this.details.agencyLicenseFileList,
          }).then(res=>{
              this.$message.success(this.$t('view.提交成功'));
              location.reload() 
          })
      },
      beforeAvatarUpload(file){
          // image/png zip rar pdf
        if((!file.type.includes('pdf'))&&(!file.type.includes('image'))&&(!file.type.includes('zip'))&&(!file.type.includes('application/x-compressed'))){
            this.$message.error(this.$t('view.格式有误'));
            return false
        }
        return true
      },
      // 删除
      handleRemove(list, file, fileList) {
        this.$set(this.details,list,[])
        fileList.map(item=>{
            this.details[list].push({
                fileName:item.response.originalFilename,
                filePath:item.response.fileName,
                url: item.response.url, 
            })
        })
      },
      // 上传文件
      successList(list,res,file){
          if(!list)
          list=[]
          list.push({
              fileName:file.response.originalFilename,
              filePath:file.response.fileName,
              url: file.response.url, 
              type:file.response.originalFilename.split(".").pop(),
              fileSize:file.size
          })
      },
      bidCompany(){
        bidCompany(this.$store.getters.companyId).then(res=>{
            this.details=res.data

            this.details.businessLicenseFileList[0].type=this.details.businessLicenseFileList[0].fileName.split(".").pop()
            this.details.achievementFileList[0].type=this.details.achievementFileList[0].fileName.split(".").pop()
            this.details.agencyLicenseFileList[0].type=this.details.agencyLicenseFileList[0].fileName.split(".").pop()
             
        })
      },  
      
    }
};
  </script>
  <style lang="scss" scoped>
  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }
  ::v-deep.hide .el-upload--text{
      display: none;
  }
  .annexList{
      display: flex;
      margin-bottom: 20px;
      font-size: 14px;
      color: #303133;
      div:first-child{
          color: #909399;        
      }
  }
  .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
  }
  </style>
   